import { SearchFormConfig } from '@awazevr/design-system.compositions.search-form'
import { Environment, Suggestion } from './SearchForm.types'
import { Destination } from '@awazevr/mfe-common.api.places-api/dist/types'

type AutocompleteSubtitleLocation = Pick<
  Suggestion,
  'countryName' | 'name' | 'parentName' | 'subtitle'
>

export const getUrlForEnv = (environment: Environment): string => {
  return (
    process.env.NEXT_PUBLIC_LOCATION_API_URL ??
    process.env.LOCATION_API_URL ??
    `https://location-lookup.api.${environment}.age.awaze.com`
  )
}

const destinationIdentifierFromLocale = (
  locale?: string,
):
  | 'da'
  | 'de'
  | 'de-at'
  | 'de-ch'
  | 'en'
  | 'en-us'
  | 'es'
  | 'fi'
  | 'fr'
  | 'hr'
  | 'hu'
  | 'it'
  | 'nb'
  | 'nl'
  | 'nl-be'
  | 'pl'
  | 'sv' => {
  switch (locale?.toLocaleLowerCase() || '') {
    case 'da':
    case 'da-dk':
      return 'da'

    case 'de':
    case 'de-de':
      return 'de'

    case 'de-at':
      return 'de-at'

    case 'de-ch':
      return 'de-ch'

    case 'en':
    case 'en-gb':
      return 'en'

    case 'en-us':
      return 'en-us'

    case 'es':
      return 'es'

    case 'fi':
      return 'fi'

    case 'fr':
      return 'fr'

    case 'hr':
      return 'hr'

    case 'hu':
      return 'hu'

    case 'it':
      return 'it'

    case 'nb':
      return 'nb'

    case 'nl':
    case 'nl-nl':
      return 'nl'

    case 'nl-be':
      return 'nl-be'

    case 'pl':
      return 'pl'

    case 'sv':
      return 'sv'
  }
  throw new Error(`No destinations exist for unexpected locale ${locale}.`)
}

export const getHardcodedDestinationData = async (
  locale: string,
  id?: string,
  brand?: string,
): Promise<Destination | null> => {
  const fileIdentifier = destinationIdentifierFromLocale(locale)

  const response = fetch(
    `/api/landing-pages/public/${brand}/json-destinations?fileIdentifier=${fileIdentifier}&id=${
      id ?? 'countries'
    }`,
  )

  try {
    const res = await response
    return await res.json()
  } catch (error) {
    if (newrelic) {
      newrelic.noticeError?.(error)
    }
    return undefined
  }
}

// Close the current open drawer if cookie consent pops up.
export const closeSearchformDrawers = (data: Event & { detail }): void => {
  const drawersOpen = document.querySelectorAll('button[title="Close drawer"]')
  if (
    data.detail.source === 'FIRST_LAYER' &&
    data.detail.type === 'CMP_SHOWN' &&
    drawersOpen?.[0]
  ) {
    const drawer = drawersOpen[0] as HTMLElement
    drawer.click?.()
  }
}

export const getAccommodationType = (
  brand: string,
  slug: string,
  config: SearchFormConfig,
): string | number => {
  switch (true) {
    case brand === 'hoseasons' && slug === 'lodges':
      return 'lodges'
    case brand === 'hoseasons' && slug === 'cottages':
      return 'cottages'
    case brand === 'hoseasons' && slug === 'holiday-parks':
      return 'holiday-parks'
    default:
      return config?.accommodationType?.defaultValue
  }
}

export const formatAutocompleteSubtitle = (
  location: AutocompleteSubtitleLocation,
): string => {
  if (location.subtitle) return location.subtitle
  if (location.countryName == location.name) return ''
  if (location.parentName && location.parentName == location.countryName)
    return location.countryName
  if (location.parentName && location.countryName)
    return `${location.parentName}, ${location.countryName}`
  return ''
}
